<template>
  <app-multiselect
    :value="selectedOption"
    :options="options"
    label="label"
    track-by="value"
    :searchable="false"
    :allow-empty="false"
    select-label=""
    deselect-label=""
    selected-label=""
    :class="sizeClass"
    @input="onInput"
  />
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import AppMultiselect from '@/components/AppMultiselect'
import useNominationLists from '@/composables/nominations/useNominationLists'

export default defineComponent({
  name: 'NominationListSelect',
  components: { AppMultiselect },
  props: {
    value: { type: String, required: true },
    sizeClass: { type: String, default: null }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const { listItems } = useNominationLists()
    const options = computed(() => listItems.value.filter(l => l.value !== 'scratchedByUser'))
    const selectedOption = computed(() => options.value.find(l => l.value === props.value))

    function onInput(option) {
      emit('input', option.value)
    }

    return { options, selectedOption, onInput }
  }
})
</script>



// WEBPACK FOOTER //
// src/views/Nominations/components/NominationListSelect.vue